import { render, staticRenderFns } from "./resList.vue?vue&type=template&id=034535e9&scoped=true&"
import script from "./resList.vue?vue&type=script&lang=ts&"
export * from "./resList.vue?vue&type=script&lang=ts&"
import style0 from "./resList.vue?vue&type=style&index=0&id=034535e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034535e9",
  null
  
)

export default component.exports